<template>
  <div
    class="accordion-block"
    :class="{'accordion-block--white': white, 'accordion-block--toggle-right': toggleRight}">
    <details
      class="accordion-block__content"
      :open="defaultExpanded">
      <summary class="accordion-block__title">
        <template v-if="toggleRight">
          <h3 class="accordion-block__title-text" :class="{'accordion-block__title-text--bold': boldTitle}">
            {{ title }}
          </h3>
          <span class="accordion-block__toggle-button"></span>
        </template>

        <template v-else>
          <span class="accordion-block__toggle-button"></span>
          <h3 class="accordion-block__title-text">
            {{ title }}
          </h3>
        </template>
      </summary>

      <div class="accordion-block__panel">
        <slot/>
      </div>
    </details>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  boldTitle?: boolean;
  defaultExpanded?: boolean;
  white?: boolean;
  toggleRight?: boolean;
}>();
</script>
